import { isIos } from "../../libs";

export function FixedBottom({ children }) {

    return (
        <div className={`nav container justify-content-around border-top bg-white ${isIos() ? 'pb-3' : 'p-0'}`}>
            {children}
        </div>
    );
}